import { ComponentPropsWithRef } from "react";
import {
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  MultipleFieldErrors,
} from "react-hook-form";
import styled from "styled-components";
import { semanticGreen, shade0, shade700 } from "@songtradr/design-language";

// TEXT

// STYLES
export const IconContainer = styled.div<{ $checked: boolean }>`
  transition: all 0.4s;
  transform: rotateY(${({ $checked }) => ($checked ? "360deg" : "0deg")});
`;
// DATA

// TYPES
export type Props = {
  passwordError?:
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<FieldValues>>
    | MultipleFieldErrors;
};

export type RuleProps = {
  errorType: string;
  errorMsg: string;
  error?: FieldError;
};

// CONSTANTS

// FUNCTIONS
export const isFieldErrorWithTypes = (
  error:
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<FieldValues>>
    | MultipleFieldErrors
    | undefined,
): error is FieldError & { types: Record<string, FieldValues> } => {
  return !!error && "types" in error && typeof error.types === "object";
};

// ASSETS
export const ConfirmedIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill={semanticGreen} />
    <path
      d="M10.2449 15.9447L7.39884 13.0987C7.28372 12.9835 7.28372 12.7964 7.39884 12.6813L8.65096 11.4292C8.76608 11.314 8.95322 11.314 9.06834 11.4292L10.2449 12.6057C10.36 12.7208 10.5472 12.7208 10.6623 12.6057L14.9317 8.33634C15.0468 8.22122 15.2339 8.22122 15.349 8.33634L16.6012 9.58846C16.7163 9.70358 16.7163 9.89072 16.6012 10.0058L10.6623 15.9447C10.5472 16.0598 10.36 16.0598 10.2449 15.9447V15.9447Z"
      fill={shade0}
    />
  </svg>
);

export const UnconfirmedIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx="12" cy="12" r="11.5" stroke={shade700} />
    <rect x="6" y="10.5" width="12" height="3" rx="0.5" fill={shade0} />
  </svg>
);
